export class Page {
  static getLanguage() {
    return document.querySelector('html').lang;
  }
}
